const XLogo = () => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="28" height="28" rx="8" fill="white"/>
    <path d="M4.04826 5L11.6901 14.8715L4 22.8974H5.73073L12.4634 15.8706L17.9032 22.8974H23.793L15.7212 12.4707L22.879 5H21.1483L14.9479 11.4716L9.93801 5H4.04826ZM6.59343 6.23164H9.29919L21.2474 21.6656H18.5416L6.59343 6.23164Z" fill="black"/>
  </svg>
);
export default XLogo;
